import { render } from "./RevenueChartCard.vue?vue&type=template&id=1b0223f5"
import script from "./RevenueChartCard.vue?vue&type=script&lang=js"
export * from "./RevenueChartCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/yandry/Downloads/s3-integration-app-web-prod(1)/s3-integration-app-web-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__